module.exports = __webpack_public_path__ + "img/lianxi_women.f0dd2547.svg";